(function () {
  'use strict';

  if (window.__soulyshineHighVariantPickerInstalled) return;
  window.__soulyshineHighVariantPickerInstalled = true;
  document.documentElement.setAttribute('data-soulyshine-high-variant-picker', 'ajax-v2');
  document.documentElement.setAttribute('data-soulyshine-page-instance', Date.now().toString(36));

  var requests = new WeakMap();
  var confirmed = new WeakMap();
  var maintenanceTimer = null;

  function pickerFor(target) {
    if (!target || !target.closest) return null;
    var picker = target.closest('[data-high-variant-picker="true"]');
    if (!picker) return null;
    if (target.matches('select, input[type="radio"]')) return picker;
    return null;
  }

  function selectedControls(picker) {
    return Array.prototype.slice.call(
      picker.querySelectorAll('select, input[type="radio"]:checked')
    ).map(function (control) {
      return control.matches('select') ? control.selectedOptions[0] : control;
    }).filter(Boolean);
  }

  function selectedControl(picker) {
    var controls = selectedControls(picker);
    return controls[controls.length - 1] || null;
  }

  function selectedOptionValueIds(picker) {
    return selectedControls(picker).map(function (control) {
      return control.getAttribute('data-option-value-id');
    }).filter(Boolean);
  }

  function selectedVariantId(productInfo, picker) {
    var input = productInfo && productInfo.querySelector(
      'form[action*="/cart/add"] input[name="id"], input.product-variant-id[name="id"]'
    );
    if (input && input.value) return input.value;
    var control = picker && selectedControl(picker);
    return control && control.getAttribute('data-variant-id');
  }

  function syncVariantInputs(picker, variantId) {
    var sectionId = picker && picker.getAttribute('data-section');
    var productSection = sectionId && document.getElementById('MainProduct-' + sectionId);
    if (!variantId || !productSection) return;
    productSection.setAttribute('data-soulyshine-variant-id', variantId);
    productSection.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
  }

  function stabilizeVariantInputs(picker, variantId) {
    syncVariantInputs(picker, variantId);
    [0, 100, 500, 1500, 3000, 5000, 10000].forEach(function (delay) {
      window.setTimeout(function () {
        if (picker.isConnected) syncVariantInputs(picker, variantId);
      }, delay);
    });
  }

  function maintainCurrentVariantInputs() {
    document.querySelectorAll('[data-high-variant-picker="true"]').forEach(function (picker) {
      var sectionId = picker.getAttribute('data-section');
      var productInfo = sectionId && document.getElementById('ProductInfo-' + sectionId);
      var variantId = selectedVariantId(productInfo, picker);
      if (variantId) syncVariantInputs(picker, variantId);
    });
  }

  function startInputMaintenance() {
    if (maintenanceTimer) window.clearInterval(maintenanceTimer);
    var runsLeft = 30;
    maintainCurrentVariantInputs();
    maintenanceTimer = window.setInterval(function () {
      maintainCurrentVariantInputs();
      runsLeft -= 1;
      if (runsLeft <= 0) {
        window.clearInterval(maintenanceTimer);
        maintenanceTimer = null;
      }
    }, 500);
  }

  function updateUrl(picker, variantId) {
    if (!variantId || picker.getAttribute('data-update-url') === 'false') return;
    var nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('variant', variantId);
    nextUrl.searchParams.delete('option_values');
    nextUrl.searchParams.delete('section_id');
    window.history.replaceState({}, '', nextUrl.toString());
  }

  function focusReplacement(previousControl, nextPicker) {
    if (!previousControl || document.activeElement !== document.body) return;
    var name = previousControl.getAttribute('name');
    var value = previousControl.value;
    var candidates = nextPicker.querySelectorAll('select, input[type="radio"]');
    for (var index = 0; index < candidates.length; index += 1) {
      if (candidates[index].getAttribute('name') === name && candidates[index].value === value) {
        candidates[index].focus({ preventScroll: true });
        return;
      }
    }
  }

  function syncLittleGirlNativeMedia(picker) {
    // This product uses Shopify-native media across 273 variants. The existing
    // section-based option picker must also activate the returned variant image.
    if (!picker || !((picker.getAttribute('data-url') || '').endsWith('/little-girl-shapes-hairstyles-charm') || (picker.getAttribute('data-url') || '').endsWith('/woman-shapes-hairstyles-charm'))) return;
    var sectionId = picker.getAttribute('data-section');
    var control = selectedControl(picker);
    var mediaId = control && control.getAttribute('data-media-id');
    var gallery = sectionId && document.getElementById('MediaGallery-' + sectionId);
    if (!gallery || !mediaId || typeof gallery.setActiveMedia !== 'function') return;
    var fullMediaId = sectionId + '-' + mediaId;
    var slide = gallery.querySelector('[data-media-id="' + fullMediaId + '"]');
    // Same-color materials share the media ID: do not reset or reload the image.
    if (!slide || slide.classList.contains('is-active')) return;
    gallery.setActiveMedia(fullMediaId, true);
  }

  function runProductHooks(nextPicker) {
    syncLittleGirlNativeMedia(nextPicker);
    if (window.SoulyshineStandingDogImages && typeof window.SoulyshineStandingDogImages.update === 'function') {
      window.SoulyshineStandingDogImages.update(nextPicker);
    }
    document.dispatchEvent(new CustomEvent('soulyshine:variant:updated', {
      detail: { picker: nextPicker }
    }));
  }

  function syncStandingDogCartImage(picker) {
    if (window.SoulyshineStandingDogImages && typeof window.SoulyshineStandingDogImages.update === 'function') {
      window.SoulyshineStandingDogImages.update(picker);
    }
  }

  function rememberSelection(picker) {
    confirmed.set(picker, Array.from(picker.querySelectorAll('select, input[type="radio"]')).map(function (control) {
      return {name: control.name, value: control.value, checked: control.checked, select: control.matches('select')};
    }));
  }

  function restoreSelection(picker) {
    var previous = confirmed.get(picker);
    if (!previous) return;
    picker.querySelectorAll('select, input[type="radio"]').forEach(function (control) {
      var saved = previous.find(function (entry) { return entry.name === control.name && (entry.select || entry.value === control.value); });
      if (saved) { if (saved.select) control.value = saved.value; else control.checked = saved.checked; }
    });
  }

  function previewSelection(picker) {
    if (window.SoulyshineInstantMedia) window.SoulyshineInstantMedia.update(picker);
    if (window.SoulyshineStandingDogImages?.preview) window.SoulyshineStandingDogImages.preview(picker);
  }

  async function renderSelection(picker, changedControl) {
    var sectionId = picker.getAttribute('data-section');
    var optionValueIds = selectedOptionValueIds(picker);
    if (!sectionId || !picker.dataset.url || !optionValueIds.length) return;

    var previousRequest = requests.get(picker);
    if (previousRequest) previousRequest.abort();
    var controller = new AbortController();
    requests.set(picker, controller);

    var currentInfo = document.getElementById('ProductInfo-' + sectionId);
    var productSection = document.getElementById('MainProduct-' + sectionId);
    picker.setAttribute('aria-busy', 'true');
    if (currentInfo) currentInfo.setAttribute('aria-busy', 'true');
    if (window.SoulyshineHairPicker) window.SoulyshineHairPicker.start(picker);

    var requestUrl = new URL(picker.dataset.url, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);
    requestUrl.searchParams.set('option_values', optionValueIds.join(','));

    try {
      previewSelection(picker);
      var response = await fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Section request failed with HTTP ' + response.status);

      var markup = await response.text();
      if (requests.get(picker) !== controller) return;
      var parsed = new DOMParser().parseFromString(markup, 'text/html');
      var nextInfo = parsed.getElementById('ProductInfo-' + sectionId);
      var nextPicker = nextInfo && nextInfo.querySelector(
        '[data-high-variant-picker="true"]'
      );
      if (!currentInfo || !nextInfo || !nextPicker) {
        throw new Error('Section response did not include the expected product markup.');
      }
      var variantId = selectedVariantId(nextInfo, nextPicker);
      if (!variantId || JSON.stringify(selectedOptionValueIds(nextPicker)) !== JSON.stringify(optionValueIds)) {
        throw new Error('Shopify did not resolve the selected option combination.');
      }

      // Keep this product's initialized delivery app DOM and its listeners.
      // Section HTML contains editor-only placeholders whose inline scripts do
      // not execute when inserted with replaceWith.
      if (((picker.getAttribute('data-url') || '').endsWith('/little-girl-shapes-hairstyles-charm') || (picker.getAttribute('data-url') || '').endsWith('/woman-shapes-hairstyles-charm'))) {
        var shippingBlock = currentInfo.querySelector('[id*="synctrack_edd_omega_estimated_shipping"]');
        var nextShippingBlock = nextInfo.querySelector('[id*="synctrack_edd_omega_estimated_shipping"]');
        if (shippingBlock && nextShippingBlock) nextShippingBlock.replaceWith(shippingBlock);
      }
      if (window.SoulyshineHairPicker) window.SoulyshineHairPicker.beforeRender(picker);
      currentInfo.replaceWith(nextInfo);
      rememberSelection(nextPicker);

      stabilizeVariantInputs(nextPicker, variantId);
      updateUrl(nextPicker, variantId);
      focusReplacement(changedControl, nextPicker);
      runProductHooks(nextPicker);
      startInputMaintenance();
      if (productSection) productSection.removeAttribute('data-variant-error');
    } catch (error) {
      if (requests.get(picker) !== controller || error.name === 'AbortError') return;
      console.error('[Soulyshine high-variant picker]', error);
      if (productSection) productSection.setAttribute('data-variant-error', 'true');
      picker.removeAttribute('aria-busy');
      if (currentInfo) currentInfo.removeAttribute('aria-busy');
      if (window.SoulyshineHairPicker) window.SoulyshineHairPicker.failed(picker);
      restoreSelection(picker);
      previewSelection(picker);
    } finally {
      if (requests.get(picker) === controller) requests.delete(picker);
    }
  }

  function syncInitialState() {
    document.querySelectorAll('[data-high-variant-picker="true"]').forEach(function (picker) {
      rememberSelection(picker);
      var sectionId = picker.getAttribute('data-section');
      var productInfo = sectionId && document.getElementById('ProductInfo-' + sectionId);
      var variantId = selectedVariantId(productInfo, picker);
      if (variantId) stabilizeVariantInputs(picker, variantId);
      runProductHooks(picker);
    });
    startInputMaintenance();
  }

  document.addEventListener('change', function (event) {
    var picker = pickerFor(event.target);
    if (!picker) return;

    // The bundled theme reads only product.variants (capped at 250). Prevent
    // that handler from resolving the wrong variant, then render this section
    // with Shopify's complete option-value endpoint instead.
    event.stopImmediatePropagation();
    renderSelection(picker, event.target);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('button[name="add"], button.product-form__submit, [data-add-to-cart]')
      : null;
    if (!button) return;
    var section = button.closest('[id^="MainProduct-"]');
    var picker = section && section.querySelector('[data-high-variant-picker="true"]');
    if (picker && requests.has(picker)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    var sectionId = picker && picker.getAttribute('data-section');
    var productInfo = sectionId && document.getElementById('ProductInfo-' + sectionId);
    var variantId = selectedVariantId(productInfo, picker);
    if (variantId) {
      if (button.form) button.form.setAttribute('data-soulyshine-click-variant-id', variantId);
      syncVariantInputs(picker, variantId);
      syncStandingDogCartImage(picker);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    var section = form.closest('[id^="MainProduct-"]');
    var picker = section && section.querySelector('[data-high-variant-picker="true"]');
    if (picker && requests.has(picker)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    var sectionId = picker && picker.getAttribute('data-section');
    var productInfo = sectionId && document.getElementById('ProductInfo-' + sectionId);
    var variantId = selectedVariantId(productInfo, picker);
    if (variantId) {
      form.setAttribute('data-soulyshine-submit-variant-id', variantId);
      syncVariantInputs(picker, variantId);
      syncStandingDogCartImage(picker);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInitialState, { once: true });
  } else {
    syncInitialState();
  }
})();

(function () {
  'use strict';
  if (customElements.get('ss-hair-picker')) return;
  var pendingFocus = null;

  class HairPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.trigger = this.querySelector('.ss-hair-trigger');
      this.panel = this.querySelector('.ss-hair-panel');
      this.header = this.querySelector('.ss-hair-sheet-header');
      this.grid = this.querySelector('.ss-hair-grid');
      this.scroller = this.querySelector('.ss-hair-scroll');
      this.status = this.querySelector('.ss-hair-status');
      this.feedback = this.querySelector('.ss-hair-feedback');
      if (!this.trigger || !this.panel || !this.grid) return;
      this.ready = true;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.onMode = this.setMode.bind(this);
      this.mobile.addEventListener('change', this.onMode);
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('.ss-hair-close').addEventListener('click', () => this.close());
      this.addEventListener('click', (event) => {
        var label = event.target.closest('.ss-hair-card');
        if (!label || !this.dialog || !this.dialog.open || this.busy) return;
        var radio = document.getElementById(label.htmlFor);
        // Selecting the already-active style needs no variant request.
        if (radio && radio.checked) this.close();
      });
      this.setMode();
    }
    disconnectedCallback() {
      if (this.mobile && this.onMode) this.mobile.removeEventListener('change', this.onMode);
      this.close(false);
      this.restoreButtons();
    }
    setMode() {
      var supported = window.HTMLDialogElement && typeof HTMLDialogElement.prototype.showModal === 'function';
      if (this.mobile.matches && supported) {
        if (!this.dialog) {
          this.dialog = document.createElement('dialog');
          this.dialog.className = 'ss-hair-dialog';
          this.dialog.id = this.trigger.getAttribute('aria-controls');
          this.dialog.setAttribute('aria-labelledby', this.header.querySelector('h2').id);
          this.dialog.append(this.panel);
          this.append(this.dialog);
          this.dialog.addEventListener('close', () => this.finishClose());
          this.dialog.addEventListener('click', (event) => {
            if (event.target !== this.dialog) return;
            var rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
          });
        }
        this.trigger.hidden = false;
        this.header.hidden = false;
        this.classList.add('ss-hair-mobile');
      } else {
        this.close(false);
        this.append(this.panel);
        if (this.dialog) this.dialog.remove();
        this.dialog = null;
        this.trigger.hidden = true;
        this.header.hidden = true;
        this.classList.remove('ss-hair-mobile');
      }
    }
    open() {
      if (!this.dialog || this.dialog.open || this.busy) return;
      this.returnFocus = true;
      this.scrollLock = {y: window.scrollY, styles: {}};
      ['position','top','left','right','width','overflow'].forEach((key) => { this.scrollLock.styles[key] = document.body.style[key]; });
      Object.assign(document.body.style, {position:'fixed',top:-this.scrollLock.y+'px',left:'0',right:'0',width:'100%',overflow:'hidden'});
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded','true');
      var selected = this.grid.querySelector('input:checked');
      this.querySelector('.ss-hair-close').focus({preventScroll:true});
      if (selected && this.scroller) {
        // Safari does not reliably scroll a fieldset. Scroll only our DIV,
        // never the dialog or page, so the close button remains in view.
        var choiceRect = selected.closest('.ss-hair-choice').getBoundingClientRect();
        var scrollRect = this.scroller.getBoundingClientRect();
        if (choiceRect.bottom > scrollRect.bottom) this.scroller.scrollTop += choiceRect.bottom - scrollRect.bottom + 12;
        else if (choiceRect.top < scrollRect.top) this.scroller.scrollTop += choiceRect.top - scrollRect.top - 12;
      }
    }
    close(returnFocus) {
      this.returnFocus = returnFocus !== false;
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.finishClose();
    }
    finishClose() {
      if (this.trigger) this.trigger.setAttribute('aria-expanded','false');
      if (this.scrollLock) {
        var saved = this.scrollLock;
        this.scrollLock = null;
        Object.assign(document.body.style, saved.styles);
        window.scrollTo({top:saved.y,left:0,behavior:'instant'});
      }
      if (this.returnFocus && this.isConnected && this.trigger && !this.trigger.hidden) this.trigger.focus({preventScroll:true});
      this.returnFocus = false;
    }
    restoreButtons() {
      (this.savedButtons || []).forEach((entry) => {entry.button.disabled = entry.disabled;});
      this.savedButtons = [];
    }
    setBusy(busy) {
      if (busy && this.busy) return;
      if (busy) this.fromSheet = !!(this.dialog && this.dialog.open);
      this.busy = busy;
      this.grid.disabled = busy;
      this.trigger.disabled = busy;
      this.status.textContent = busy ? 'Updating selection…' : '';
      this.status.hidden = !busy;
      this.feedback.hidden = true;
      if (busy) {
        this.savedButtons = [];
        var section = this.closest('[id^="MainProduct-"]');
        if (section) section.querySelectorAll('button[name="add"]').forEach((button) => {
          this.savedButtons.push({button:button,disabled:button.disabled});
          button.disabled = true;
        });
      } else this.restoreButtons();
    }
    failed() {
      this.setBusy(false);
      // Restore the previously committed radio; the failed choice must be retryable.
      var picker = this.closest('[data-high-variant-picker]') || this;
      picker.querySelectorAll('input[type="radio"]').forEach((radio) => {radio.checked = radio.defaultChecked;});
      picker.querySelectorAll('select option').forEach((option) => {option.selected = option.defaultSelected;});
      this.status.textContent = 'Could not update selection. Please try again.';
      this.status.hidden = false;
      this.feedback.textContent = this.status.textContent;
      this.feedback.hidden = !!(this.dialog && this.dialog.open);
      if (this.fromSheet && this.dialog && !this.dialog.open) this.trigger.focus({preventScroll:true});
      this.fromSheet = false;
    }
  }
  customElements.define('ss-hair-picker', HairPicker);

  window.SoulyshineHairPicker = {
    start: function (picker) {
      var hair = picker.querySelector('ss-hair-picker');
      if (hair) hair.setBusy(true);
    },
    beforeRender: function (picker) {
      var hair = picker.querySelector('ss-hair-picker');
      if (!hair) return;
      pendingFocus = hair.fromSheet || (hair.dialog && hair.dialog.open) || document.activeElement === hair.trigger ? picker.getAttribute('data-section') : null;
      hair.close(false);
    },
    failed: function (picker) {
      var hair = picker.querySelector('ss-hair-picker');
      if (hair) hair.failed();
    }
  };
  function element(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function enhance(root) {
    root.querySelectorAll('.product-form__input--hair-cards').forEach(function (area) {
      if (area.querySelector('ss-hair-picker')) return;
      var picker = area.closest('[data-high-variant-picker]');
      var url = picker && picker.getAttribute('data-url') || '';
      if (!url.endsWith('/little-girl-shapes-hairstyles-charm') && !url.endsWith('/woman-shapes-hairstyles-charm')) return;
      var grid = area.querySelector('.ss-hair-grid');
      var selected = grid && grid.querySelector('input:checked');
      if (!selected) return;
      var count = grid.querySelectorAll('input[type="radio"]').length;
      var id = 'HairSheet-' + selected.id;
      var host = element('ss-hair-picker','');
      var trigger = element('button','ss-hair-trigger');
      trigger.type = 'button'; trigger.hidden = true;
      trigger.setAttribute('aria-haspopup','dialog');
      trigger.setAttribute('aria-expanded','false');
      trigger.setAttribute('aria-controls',id);
      trigger.setAttribute('aria-label','Choose hairstyle. Selected: '+selected.value+'. '+count+' styles available.');
      var sourceImage = selected.closest('.ss-hair-choice').querySelector('img');
      if (sourceImage) {
        var image = sourceImage.cloneNode(true);
        image.width = 54; image.height = 68; image.alt = ''; image.loading = 'eager';
        trigger.append(image);
      }
      var copy = element('span','ss-hair-trigger-copy');
      copy.append(element('strong','',selected.value),element('small','',count+' hairstyles · Tap to choose'));
      trigger.append(copy,element('span','ss-hair-trigger-action','Change ›'));
      var feedback = element('p','ss-hair-feedback'); feedback.hidden = true; feedback.setAttribute('role','alert');
      var panel = element('div','ss-hair-panel');
      var header = element('div','ss-hair-sheet-header'); header.hidden = true;
      var heading = element('div','');
      var title = element('h2','','Choose hairstyle'); title.id = id+'-title';
      heading.append(title,element('p','',count+' styles · Tap a photo to select'));
      var close = element('button','ss-hair-close','×'); close.type = 'button'; close.setAttribute('aria-label','Close hairstyle chooser');
      header.append(heading,close);
      var status = element('p','ss-hair-status'); status.hidden = true; status.setAttribute('role','status'); status.setAttribute('aria-live','polite');
      panel.append(header,status);
      var help = area.querySelector('.ss-hair-help'); if (help) panel.append(help);
      var scroller = element('div','ss-hair-scroll');
      scroller.append(grid); panel.append(scroller); host.append(trigger,feedback,panel); area.append(host);
    });
  }
  document.addEventListener('soulyshine:variant:updated', function (event) {
    var picker = event.detail && event.detail.picker;
    if (picker) enhance(picker);
    if (!picker || !pendingFocus || pendingFocus !== picker.getAttribute('data-section')) return;
    var trigger = picker.querySelector('.ss-hair-trigger');
    if (trigger && !trigger.hidden) trigger.focus({preventScroll:true});
    pendingFocus = null;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () {enhance(document);},{once:true});
  else enhance(document);
})();
